
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, Plus } from 'lucide-react';

interface TemplateSearchProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onCreateTemplate: () => void;
}

export function TemplateSearch({
  searchQuery,
  onSearchChange,
  onCreateTemplate
}: TemplateSearchProps) {
  return (
    <div className="flex flex-col sm:flex-row justify-between gap-4 mb-6">
      <div className="relative flex-1">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search templates..."
          className="pl-8"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <Button 
        className="flex items-center gap-1.5"
        onClick={onCreateTemplate}
      >
        <Plus className="h-4 w-4" />
        Create Template
      </Button>
    </div>
  );
}
